import { render } from "./PensionPanel.vue?vue&type=template&id=680b18aa&scoped=true&ts=true"
import script from "./PensionPanel.vue?vue&type=script&lang=ts"
export * from "./PensionPanel.vue?vue&type=script&lang=ts"

import "./PensionPanel.vue?vue&type=style&index=0&id=680b18aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680b18aa"]])

export default __exports__